import { AppHeader, AppHeaderBackButton, Box, Container } from '@ace-clublabs/shared-component-library';
import { Pages } from '../utils/constants';
import confirmationImage from '../assets/confirmation-image.svg';
import { ConfirmationDetails } from '../components/ConfirmationDetails';
import { ConfirmationTitle } from '../components/ConfirmationDetails/ConfirmationTitle';
import { setGlobalState, useGlobalState } from '../state/state';
import { useLayoutEffect, useState } from 'react';
import { UtagHelper, UtagType } from '../utils/UtagHelper';
import { AutoPayFailedAlert } from '../components/ConfirmationDetails/AutoPayFailedAlert';

export const Confirmation: React.FC = () => {
  const [memberDetails] = useGlobalState('memberDetails');
  const [isMobileApp] = useGlobalState('isMobileApp');
  const [confirmation] = useGlobalState('confirmation');
  const [paymentInfo] = useGlobalState('paymentInfo');
  const [priceCart] = useGlobalState('priceCart');
  const [tags] = useGlobalState('tags');
  const [isTagging, setTagging] = useState(true);

  useLayoutEffect(() => {
    if (!confirmation?.confirmationId) return;
    const confirmationTags = UtagHelper.buildConfirmationTags(memberDetails, confirmation, paymentInfo, priceCart);
    UtagHelper.sendTag(UtagType.view, tags, 'confirmation', confirmationTags);
    setTagging(false);
    setGlobalState('memberDetails', { ...memberDetails, sessionId: '' });
  }, []);

  const handleReturnToMSSHomePage = () => {
    const url = window.location.href.replace('/selfservice/confirmation', `/selfservice`);
    window.history.pushState({ navigatedFrom: Pages.ConfirmationPage }, '', url);
    document.location.reload();
  };

  if (isTagging) {
    return <></>;
  }

  return (
    <>
      <Container maxWidth="sm">
        <Box
          sx={{
            marginTop: '1.5rem',
            marginLeft: 0,
          }}
        >
          <AppHeader
            backButton={
              !isMobileApp && <AppHeaderBackButton label="Back to my membership" onClick={handleReturnToMSSHomePage} />
            }
          />
          <Box
            sx={{
              width: '300px',
              height: '144px',
              margin: 'auto',
              display: 'block',
            }}
          >
            <img
              src={confirmationImage}
              alt="confirmation-image"
              className="confirmation-image"
              style={{ margin: '0 auto', display: 'block' }}
            />
          </Box>
          <ConfirmationTitle />
          <AutoPayFailedAlert />
          <ConfirmationDetails handleReturnToMSSHomePage={handleReturnToMSSHomePage} />
        </Box>
      </Container>
    </>
  );
};
